// Carpet supplier B2B portals (26 Oct 2026, docs/SUPPLIER-HUB.md §6): the SUPPLIER's stock as EmmA read it from Beaulieu
// Connect and EC Carpets this morning — never Artemis' own shelf (that is /inventory). Read by the supplier page's
// "Supplier stock" tab, the PO material line and the staff Proposal colour pick.
import {useQuery} from '@tanstack/react-query';
import {authHeaders, fetchImpl} from './api';
import {env} from './env';

export type {StockColour, StockRoll, CostReportRow, PortalRead} from './supplier-stock-words';
export {sydneyStamp, dayText, metres, stockSentence} from './supplier-stock-words';
import type {StockColour} from './supplier-stock-words';

export async function getData<T>(path: string): Promise<T> {
  const r = await fetchImpl(`${env.apiBase}${path}`, {headers: await authHeaders()});
  const body = await r.json();
  if (!r.ok) throw Error(body.error ?? 'Unavailable');
  return body.data as T;
}

/** What a supplier's portal shows of one catalogue colour; nothing when the supplier's portal is not read. */
export function useSupplierStockFor(variantId: string | null | undefined) {
  return useQuery({
    queryKey: ['supplier-stock-variant', variantId],
    queryFn: () => getData<{colours: StockColour[]}>(`/api/supplier-stock?variant_id=${encodeURIComponent(variantId!)}`),
    enabled: !!variantId, staleTime: 10 * 60 * 1000,
  });
}
